/**
 * @Author: Alex Sorafumo <Yuion>
 * @Date:   15/09/2016 12:37 PM
 * @Email:  alex@yuion.net
 * @Filename: toggle.component.ts
 * @Last modified by:   Alex Sorafumo
 * @Last modified time: 30/01/2017 10:06 AM
 */

import { Component, Input, ChangeDetectionStrategy, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { BaseFormWidgetComponent } from '../../../shared/base-form.component';

export interface IToggleOptions {
    on_text?: string;
    off_text?: string;
};

@Component({
    selector: 'toggle',
    template: `<!--
@Author: Alex Sorafumo <Yuion>
@Date:   15/09/2016 6:41 PM
@Email:  alex@yuion.net
@Filename: toggle.template.html
@Last modified by:   alex.sorafumo
@Last modified time: 24/01/2017 4:37 PM
-->

<div [class]="'toggle' + (klass ? ' ' + klass : '')" widget [class.disabled]="disabled" (touchrelease)="toggle()">
    <div class="base" [class.ios]="type==='ios'||type==='iOS'" [class.android]="type==='android'" [class.disabled]="disabled"
        [class.active]="model">
        <div class="text" [class.ios]="type==='ios'||type==='iOS'" [class.android]="type==='android'" [class.active]="model">
            {{model ? (options ? options.on_text || 'On' : 'On') : (options ? options.off_text || 'Off' : 'Off' )}}
        </div>
        <div class="knob" [class.ios]="type==='ios'||type==='iOS'" [class.android]="type==='android'" [class.disabled]="disabled"
            [class.active]="model"></div>
    </div>
</div>`,
    styles: [`.base{position:relative;background-color:#f44336;width:4.5em;height:2em;border-radius:4px;-webkit-transition:background-color .3s;transition:background-color .3s;margin:.25em .4em;border-color:#999}.base.active{background-color:#4caf50}.base.ios{width:3em;height:2em;border-radius:1em}.base.android{width:3em;height:.75em;border-radius:.4em;margin:.9em .8em}.base.disabled{background-color:#ccc}.text{height:100%;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;padding:0 .2em 0 2.2em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.text.active{padding:0 2.2em 0 .2em}.text.android,.text.ios{display:none}.knob{position:absolute;top:3px;left:3px;right:2.5em;bottom:3px;border-radius:3px;background-color:#f0f0f0;-webkit-transition:left .3s,right .3s;transition:left .3s,right .3s}.knob.active{left:2.5em;right:3px}.knob.ios{left:3px;right:1.2em;border-radius:1.2em}.knob.ios.active{right:3px;left:1.2em}.knob.android{top:-.5em;bottom:-.5em;left:-.5em;right:1.75em;border-radius:1.2em;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)}.knob.android.active{right:-.5em;left:1.75em}.knob.disabled{background-color:#999}`],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ToggleComponent),
        multi: true
    }]
})
export class ToggleComponent extends BaseFormWidgetComponent<boolean> implements ControlValueAccessor {
    @Input() public type = '';
    @Input() public options: IToggleOptions = {};

    public toggle() {
        if (!this.disabled) {
            this.model = !this.model;
            this.modelChange.emit(this.model);
            this.change(this.model);
        }
    }
}
